import { render } from "./MainUnitMeasures.vue?vue&type=template&id=2149a223&scoped=true"
import script from "./MainUnitMeasures.vue?vue&type=script&lang=js"
export * from "./MainUnitMeasures.vue?vue&type=script&lang=js"

import "./MainUnitMeasures.vue?vue&type=style&index=0&id=2149a223&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2149a223"]])

export default __exports__